import { render, staticRenderFns } from "./ClassesSelector.vue?vue&type=template&id=4c934c0c&"
import script from "./ClassesSelector.vue?vue&type=script&lang=js&"
export * from "./ClassesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports